module.exports = __webpack_public_path__ + "img/dsgvo.b8e7084d.png";